// Archivo: src/utils/GapMedioCalculator.js

export const calculateGap = (time, distance, paceSeconds, elevation, formulaType = 'ITRA') => {
  if (
    isNaN(time) || time <= 0 ||
    isNaN(distance) || distance <= 0 ||
    isNaN(paceSeconds) || paceSeconds <= 0 ||
    isNaN(elevation) || elevation < 0
  ) {
    console.error('Datos de entrada inválidos para calcular el GAP:', {
      time, distance, paceSeconds, elevation
    });
    return '00:00';
  }

  let gapAdjustment = 0;
  switch (formulaType) {
    case 'ITRA': gapAdjustment = elevation / 100; break;
    case 'UTMB': gapAdjustment = elevation / 80; break;
    case 'IAAF': gapAdjustment = elevation / 120; break;
    default:
      console.error('Fórmula de cálculo no válida');
      return '00:00';
  }

  const adjustedPace = paceSeconds + gapAdjustment;
  const minutes = Math.floor(adjustedPace / 60);
  const seconds = Math.round(adjustedPace % 60);

  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
};

export const calculateGapMedio = (laps, formulaType = 'ITRA') => {
  if (!laps || laps.length === 0) {
    console.error('No hay vueltas disponibles para calcular el GAP');
    return [];
  }

  const validLaps = laps.filter(lap =>
    !isNaN(lap.total_elapsed_time) &&
    !isNaN(lap.distance) &&
    !isNaN(lap.pace) &&
    !isNaN(lap.elevation)
  );

  if (validLaps.length === 0) {
    console.error('No hay laps válidos para calcular el GAP');
    return [];
  }

  const gaps = validLaps.map(lap => 
    calculateGap(lap.total_elapsed_time, lap.distance, lap.pace, lap.elevation, formulaType)
  );


  return gaps;
};

export const calculateAverageGap = (laps, formulaType = 'ITRA') => {
  if (!laps || laps.length === 0) {
    console.error('No hay vueltas disponibles para calcular el GAP promedio');
    return '00:00';
  }

  const validLaps = laps.filter(lap =>
    !isNaN(lap.total_elapsed_time) &&
    !isNaN(lap.distance) &&
    !isNaN(lap.pace) &&
    !isNaN(lap.elevation)
  );

  if (validLaps.length === 0) {
    console.error('No hay laps válidos para calcular el GAP promedio');
    return '00:00';
  }

  const gaps = calculateGapMedio(validLaps, formulaType);

  const totalGap = gaps.reduce((acc, gap) => {
    const [minutes, seconds] = gap.split(':').map(num => parseInt(num, 10));
    return acc + (minutes * 60 + seconds);
  }, 0);

  const averageGap = totalGap / validLaps.length;
  const avgMinutes = Math.floor(averageGap / 60);
  const avgSeconds = Math.round(averageGap % 60);

  return `${String(avgMinutes).padStart(2, '0')}:${String(avgSeconds).padStart(2, '0')}`;
};

const GapMedioCalculator = {
  calculateAverageGap,
  calculateGap,
  calculateGapMedio
};

export default GapMedioCalculator;
